import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { ListboxItem } from '@bluebeam/react-skyline-listbox';
import { useMenuItem } from '@react-aria/menu';
import { Item } from '@react-stately/collections';
import { useRef } from 'react';
import MenuItemContent from './MenuItemContent';
const MenuItem = ({ caption, children, icon, shortcut, state, value, ...rest }) => {
    const menuItemRef = useRef();
    const { isDisabled, keyboardShortcutProps, menuItemProps } = useMenuItem({
        key: value,
    }, state, menuItemRef);
    const dataAttributes = useDataAttributes(rest);
    return (_jsxs(ListboxItem, { ...menuItemProps, className: buildClassName(isDisabled ? 'cursor-default' : 'cursor-pointer', {
            'hover:bg-white': isDisabled,
            'justify-between': Boolean(shortcut),
        }), ref: menuItemRef, ...dataAttributes, children: [icon || caption ? (_jsx(MenuItemContent, { icon: icon, isDisabled: isDisabled, caption: caption, children: children })) : (children), shortcut && (_jsx("kbd", { ...keyboardShortcutProps, className: buildClassName('skyline-text-body-1 leading-5.5 text-medium-gray ml-2', {
                    'text-opacity-20': isDisabled,
                }), children: shortcut }))] }));
};
/**
 * A menu item is a listbox item that represents an action
 * available within a menu.
 */
export const ReactAriaMenuItem = () => {
    return null;
};
ReactAriaMenuItem.getCollectionNode = function* getCollectionNode(props, context) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    yield* Item.getCollectionNode(props, context);
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map